import type { Epic } from 'Flux/index.js'
import { billingSlice } from 'Flux/Slice/Billing/BillingSlice.js'
import { catchError, filter, forkJoin, map, mergeMap, of } from 'rxjs'
import type { CreditBalanceDTO } from '../../../Generated/CreditBalanceDTO.ts'
import type { CreditTransactionDTO } from '../../../Generated/CreditTransactionDTO.ts'

/**
 * Full billing load: plans + credit items always, and (only when the org has a subscription /
 * chargebee customer) the credit balance + history. Dispatched by the billing page on mount.
 */
export const LoadBillingEpic: Epic = (action$, _state$, { [billingSlice.name]: billing, BillingRepository }) =>
  action$.pipe(
    filter(billing.loadBilling.match),
    mergeMap((action) => {
      const credits$ = action.payload.includeCredits
        ? forkJoin({ balance: BillingRepository.getCredits(), transactions: BillingRepository.getCreditHistory() })
        : of({ balance: null as CreditBalanceDTO | null, transactions: [] as CreditTransactionDTO[] })

      return forkJoin({
        plans: BillingRepository.getPlans(),
        creditItems: BillingRepository.getCreditItems(),
        credits: credits$
      }).pipe(
        map(({ plans, creditItems, credits }) =>
          billing.billingLoaded({ plans, creditItems, balance: credits.balance, transactions: credits.transactions })
        ),
        catchError((error) => of(billing.billingLoadFailed({ error })))
      )
    })
  )
